import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "events-map my-4" };
const _hoisted_2 = { class: "card p-3" };
const _hoisted_3 = {
    key: 0,
    class: "map-container"
};
const _hoisted_4 = { class: "location-info mt-3" };
const _hoisted_5 = { class: "d-flex align-items-center mb-2" };
const _hoisted_6 = { class: "text-muted mb-1" };
const _hoisted_7 = { class: "text-muted mb-0" };
const _hoisted_8 = {
    key: 1,
    class: "no-location"
};
import { computed } from 'vue';
import SimpleMap from '@/components/SimpleMap.vue';
// Props para recibir el evento
export default /*@__PURE__*/ _defineComponent({
    __name: 'EventsMap',
    props: {
        event: {}
    },
    setup(__props) {
        const props = __props;
        // Computed para obtener la información de ubicación (con fallbacks)
        const eventLocation = computed(() => {
            if (!props.event)
                return null;
            const place = props.event.place || null;
            const name = place?.name || props.event.name || props.event.department?.name || null;
            const address = place?.address || props.event.address || null;
            const openingHours = place?.opening_hours || props.event.opening_hours || null;
            const contact = place?.contact_info || props.event.contact_info || null;
            if (!name && !address)
                return null;
            return {
                name: name || 'Ubicación no disponible',
                address: address || 'Dirección no disponible',
                opening_hours: openingHours,
                contact
            };
        });
        // Computed para las coordenadas del evento
        const eventCoordinates = computed(() => {
            if (!props.event?.latitude || !props.event?.longitude) {
                return [-16.2902, -63.5887]; // Coordenadas por defecto de Bolivia
            }
            return [
                parseFloat(props.event.latitude),
                parseFloat(props.event.longitude)
            ];
        });
        // Computed para los marcadores del mapa
        const eventMarkers = computed(() => {
            if (!props.event)
                return [];
            return [{
                    id: `event-${props.event.id}`,
                    nombre: props.event.name,
                    coordenadas: eventCoordinates.value,
                    descripcion: props.event.description,
                    region: props.event.place?.name || 'Bolivia',
                    tipo: 'evento',
                    destacado: true
                }];
        });
        // Computed para el zoom dinámico
        const eventZoom = computed(() => {
            const placeName = (props.event?.place?.name || props.event?.department?.name || '').toLowerCase();
            if (!placeName)
                return 10;
            // Para lugares remotos como el Salar de Uyuni, usar zoom más bajo
            if (placeName.includes('salar') || placeName.includes('uyuni')) {
                return 8;
            }
            // Para lugares en ciudades, usar zoom medio
            if (placeName.includes('oruro') || placeName.includes('la paz') ||
                placeName.includes('cochabamba') || placeName.includes('santa cruz')) {
                return 12;
            }
            // Para otros lugares, zoom por defecto
            return 10;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "mb-3" }, "Ubicación del Evento", -1)),
                    (eventLocation.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(SimpleMap, {
                                center: eventCoordinates.value,
                                zoom: eventZoom.value,
                                lugares: eventMarkers.value,
                                height: "300px"
                            }, null, 8, ["center", "zoom", "lugares"]),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fas fa-map-marker-alt text-primary me-2" }, null, -1)),
                                    _createElementVNode("strong", null, _toDisplayString(eventLocation.value.name), 1)
                                ]),
                                _createElementVNode("p", _hoisted_6, _toDisplayString(eventLocation.value.address), 1),
                                _createElementVNode("p", _hoisted_7, [
                                    _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fas fa-clock me-1" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(eventLocation.value.opening_hours), 1)
                                ])
                            ])
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[2] || (_cache[2] = [
                                _createElementVNode("i", { class: "fas fa-map-marked-alt text-muted mb-2" }, null, -1),
                                _createElementVNode("p", { class: "text-muted" }, "Ubicación no disponible", -1)
                            ]))]))
                ])
            ]));
        };
    }
});
